package br.com.heyagenda.domain.usecase

import br.com.heyagenda.domain.model.DaySchedule
import br.com.heyagenda.domain.repository.AvailabilityRepository

class UpdateDayScheduleUseCase(
    private val repository: AvailabilityRepository
) {
    suspend operator fun invoke(daySchedule: DaySchedule): Result<Unit> {
        return repository.updateDaySchedule(daySchedule)
    }
}
